function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.316 15.229L12.87 3.675l-.141 10.398 1.887-.025L14.8.429 1.181.613l-.027 1.886 10.4-.14L0 13.913l1.316 1.316z"
});

function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNSAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMzE1OCAxNS4yMjlMMTIuODY5NiAzLjY3NTE3TDEyLjcyODYgMTQuMDczM0wxNC42MTYyIDE0LjA0NzhMMTQuOCAwLjQyODk1NUwxLjE4MTIxIDAuNjEyNzUxTDEuMTU0NDIgMi40OTkxMUwxMS41NTM4IDIuMzU5MzdMMCAxMy45MTMyTDEuMzE1OCAxNS4yMjlaIiAvPgo8L3N2Zz4K";
export { SvgExternal as ReactComponent };